// extracted by mini-css-extract-plugin
module.exports = {"root":"Profile_root__3I9Xk","about":"Profile_about__35o-T"};